import Loadable from 'react-loadable'
import LoadingIndicatorFull from './LoadingIndicatorFull.js'

const LoadableAchieveScene = Loadable({
  loader: () => import('./AchieveScene.js'),
  loading: LoadingIndicatorFull,
})

export default LoadableAchieveScene
